import { createFileRoute } from '@tanstack/react-router'
import { protectedRouteGuard } from '@/utils/routeGuards'
import CreateClusterPage from '@/features/Clusters/pages/CreateClusterPage'

export const Route = createFileRoute('/infra/clusters/create')({
  beforeLoad: protectedRouteGuard,
  loader: () => ({
    crumb: 'Create Cluster',
  }),
  component: CreateClusterPage,
})
